<template>
  <div>
    <v-app-bar app class="elevation-0" color="white">
      <v-app-bar-nav-icon @click.stop="setDrawer(!drawer)"></v-app-bar-nav-icon>

      <v-spacer></v-spacer>

      <template v-if="!isMobile()">
        <v-menu
          v-model="helpMenu"
          :close-on-content-click="false"
          offset-y
          transition="slide-y-transition"
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="gray" dark v-bind="attrs" v-on="on" icon depressed>
              <v-icon>mdi-help-circle-outline</v-icon>
            </v-btn>
          </template>

          <v-card max-width="300">
            <v-card-title class="text-h5 font-weight-bold"
              >Help Desk</v-card-title
            >

            <!-- <v-divider></v-divider> -->

            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <v-card class="text-center" @click="helpDeskClicked('faq')">
                    <v-card-text>
                      <v-img
                        lazy-src="/icons/faq.png"
                        max-height="35"
                        max-width="35"
                        src="/icons/faq.png"
                        style="margin: auto"
                      ></v-img>
                      <h4 class="black--text">FAQ's</h4>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card class="text-center" @click="helpDeskClicked('task')">
                    <v-card-text>
                      <v-img
                        lazy-src="/icons/tasks.png"
                        max-height="35"
                        max-width="35"
                        src="/icons/tasks.png"
                        style="margin: auto"
                      ></v-img>
                      <h4 class="black--text">Enquiries</h4>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-card class="text-center" @click="helpDeskClicked('phone')">
                    <v-card-text>
                      <v-img
                        lazy-src="/icons/phone.png"
                        max-height="35"
                        max-width="35"
                        src="/icons/phone.png"
                        style="margin: auto"
                      ></v-img>
                      <h4 class="black--text">Contact Us</h4>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-menu>
        
        <v-menu
          v-model="bellMenu"
          :close-on-content-click="false"
          offset-y
          transition="slide-y-transition"
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="gray" dark v-bind="attrs" v-on="on" icon depressed>
              <v-icon>mdi-bell-outline</v-icon>
            </v-btn>
          </template>

          <v-card min-width="400">
            <v-row>
              <v-col cols="6">
                <v-card-title class="text-h6 font-weight-bold"
                  >Notifications</v-card-title
                >
              </v-col>
              <v-col cols="6 float-right" v-if="notifications.length >0">
                <v-radio-group class="float-right pr-4"><v-radio label=" Mark all as read" @change="handleMarkAll"  v-model="isRead"></v-radio></v-radio-group>
              </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-card-text>
              <v-list two-line>
                  <v-list-item-group>
                    <div v-if="notifications.length > 0">
                        <v-list-item v-for="(item,index) in notifications.slice(0,4)" :key="index" two-line class="px-4">
                        <v-item-action>
                          <v-icon>mdi-bell-outline</v-icon>
                        </v-item-action>
                        <v-list-item-content class="px-4">
                          <v-list-item-title v-text="`${item.body}`">
                          </v-list-item-title>
                          <v-list-item-subtitle class="mt-2" >{{ formatDate(item.createdAt) }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                    
                    <div v-else>
                      <v-list-item two-line class="px-4">
                        <v-list-item-content class="px-4 text-center">
                          <v-list-item-title v-text="`No notifications found!`">
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                   
                   
                    <div v-if="notifications.length > 4">
                      <v-divider class="my-3"></v-divider>
                    <p @click="viewAllNoty" style="cursor: pointer;" class="pt-2 green--text d-flex justify-center font-weight-bold">Read all notifications</p>
                    </div>
                  </v-list-item-group>
                </v-list>
            </v-card-text>
          </v-card>
        </v-menu>
        
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-list color="transparent">
              <v-list-item two-line>
                <v-list-item-avatar>
                  <img :lazy-src="imgURL" :src="imgURL" />
                </v-list-item-avatar>

                <v-list-item-content class="d-block">
                  <v-list-item-title>{{
                    currentUser.firstName || currentUser.userDetail.firstName
                  }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                    currentUser.email || currentUser.userDetail.email
                  }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon dark v-bind="attrs" v-on="on">
                    <v-icon class="gray--text">mdi-chevron-down</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </template>
          <v-list>
            <v-list-item two-line>
                <v-list-item-avatar>
                  <img :lazy-src="imgURL" :src="imgURL" />
                </v-list-item-avatar>

                <v-list-item-content class="d-block">
                  <v-list-item-title>{{
                    currentUser.firstName || currentUser.userDetail.firstName
                  }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                    currentUser.email || currentUser.userDetail.email
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            <v-divider></v-divider>
            <v-list-item v-if="currentUser.userDetail" @click="$router.replace({ name: 'profile' })">
              <v-icon class="px-3">mdi mdi-account-outline</v-icon> {{
              $t("editProfile")
            }}</v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="logout">
              <v-icon class="px-3">mdi mdi-logout</v-icon> {{ $t("signOut") }}
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-else></template>
      <div class="pt-5">
        <LanguageSelection :pageReload="true" />
      </div>
    </v-app-bar>
    <ContactUs :dialogU="showContactUs" @closeContactUs="closeContactUs" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import isMobileMixin from "@/mixins/isMobileMixin";
import LoadingMixin from "@/mixins/LoadingMixin";
import ProfileService from "@/_services/ProfileService";
import FarmService from "@/_services/farmService";

import ContactUs from "@/components/ContactUs.vue";
import gql from 'graphql-tag'
import moment from "moment";
export default {
  apollo: {
    getNotifications: {
      query: gql`
        query unseenNotifications {
          unseenNotifications {
            id
            redirection_url
            module_name
            body
            createdAt
          }
        }
      `,
      fetchPolicy: "network-only",
      update:(data)=>data.unseenNotifications,
      result({data}){
        this.notifications=data.unseenNotifications;
      }
    },
  },
  components: {
    ContactUs,
  },
  computed: {
    ...mapState(["drawer"]),
    currentUser() {
      return this.$store.getters.getUser;
    },
  },
  created() {
    this.getProfileData();
    this.getMyFarm();
  },
  data() {
    return {
      imgURL: "/img/user.jpg",
      helpMenu: false,
      bellMenu:false,
      showContactUs: false,
      notifications:[],
      isRead:false,
    };
  },
  methods: {
    formatDate(date){
      return moment(date).format('h:mm A, MMMM Do YYYY');
    },
    async handleMarkAll(){
      this.startLoading();
      this.$apollo.mutate({
        mutation:gql `
          mutation markAllRead{
            markAllRead
          }
        `
      })
      .then(async()=>{
            this.$notify({
            title: `Marked all notifications as a read.`,
            text: "",
            type: "success",
          });
          this.$apollo.queries.getNotifications.refetch();
          this.stopLoading();
        })
        .catch(async (error) => {
          console.log(error);
          this.stopLoading();
        });
    },
    viewAllNoty(){
      this.$router.push({name:'Notifications'});
      this.bellMenu=false;
    },
    helpDeskClicked(type) {
      this.helpMenu = false;
      if (type == "faq") {
        this.$router.push({ name: "Faq" });
      } else if (type == "task") {
        this.$router.push({ name: "Enquiries" });
      } else {
        this.showContactUs = true;
      }
    },
    closeContactUs() {
      this.showContactUs = false;
    },
    setDrawer(val) {
      this.$store.commit("SET_DRAWER", val);
    },
    async logout() {
      this.startLoading();
      await this.$store.dispatch("logout");
      await this.$store.dispatch("resetFarm");
      localStorage.removeItem("farmID");
      this.stopLoading();
      this.$router.replace({ name: "login" });
    },
    getProfileData() {
      ProfileService.getProfileData()
        .then((res) => {
          if (
            res.success &&
            res.data.profilePicUrl != "" &&
            res.data.profilePicUrl != null
          ) {
            this.imgURL = res.data.profilePicUrl;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async getMyFarm() {
      const { data } = await FarmService.getPrimaryFarm();
      await this.$store.dispatch("setFarmData", data);
      // localStorage.setItem('farmID',data.id);
    },
  },
  mixins: [isMobileMixin, LoadingMixin],
};
</script>

<style scoped></style>
